import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useRef, useEffect, useState } from 'react';
import MediaQuery from 'react-responsive';
import { useMediaQuery } from 'react-responsive';
import { AcornsIcon } from '@acorns/icons';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { ActionButton } from '../ActionButton';
import { SavedLabel } from '../SavedLabel';
import { ACTION_STRIP } from '../utils/testing/TestIDs';
import { ScreenReaderOnly } from '../ScreenReaderOnly';
import { theme } from '../theme';
import { handleBackAction } from '../utils/history';
import { ACTION_STRIP_SUBTEXT, ACTION_STRIP_TITLE, UNDERLINE } from '../utils/testing/TestIDs';
import { InvertedStrip } from './InvertedStrip';
import { useStickyScroll } from './hooks';
import { TitleContainer, Title, Subtitle, VerticalSubTextContainer, HorizontalSubtextContainer, SettingsButtonStyled, BackButtonStyled, ActionContainer, SideNavContainer as Container, Underline, SideNavConstrainer as Constrainer, SideNavContent as Content } from './styled-components';
var defaultProps = {
  disableResponsiveSticky: false,
  maxWidth: 1200,
  preventDefault: false,
  showBack: true,
  showInverted: false,
  showResponsiveTitle: true,
  hasStickySettings: false,
  stripColor: theme.colors.white,
  invertedStripColor: theme.colors.green,
  invertedStripTransitionColor: theme.colors.white,
  showTitleOnLoad: false,
  showSubtextOnLoad: false,
  showChildrenIconsOnLoad: false,
  titleColorOnLoad: theme.colors.slate,
  subtextColorOnLoad: theme.colors.slate,
  stickyScroll: true,
  actionBackgroundColor: theme.colors.ivory,
  minWidthToShowButtonText: 600,
  withSideBarNav: false,
  leftActions: []
};
export var SideNavActionStrip = function SideNavActionStrip(props) {
  var _ref$current, _ref$current2;

  var history = useHistory();
  var location = useLocation();
  var match = useRouteMatch();
  var ref = useRef(null);

  var useWindowSize = function useWindowSize(width) {
    var _useState = useState({
      width: undefined
    }),
        _useState2 = _slicedToArray(_useState, 2),
        windowSize = _useState2[0],
        setWindowSize = _useState2[1];

    useEffect(function () {
      var handleResize = function handleResize() {
        setWindowSize({
          width: width
        });
      }; // Add event listener


      window.addEventListener('resize', handleResize); // Call handler right away so state gets updated with initial window size

      handleResize(); // Remove event listener on cleanup

      return function () {
        return window.removeEventListener('resize', handleResize);
      };
    }, []); // Empty array ensures that effect is only run on mount

    return windowSize;
  };

  useWindowSize(ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.offsetWidth);
  props = _objectSpread(_objectSpread({}, defaultProps), props);
  props.maxWidth = !props.withSideBarNav || props.maxWidth < 1200 ? props.maxWidth : null;

  var _useStickyScroll = useStickyScroll({
    scrollDistance: 64
  }),
      scrollPercent = _useStickyScroll.scrollPercent;

  var isDesktop = useMediaQuery({
    query: "(min-width: ".concat(theme.breakpoints.sm + 1, "px)")
  });
  var hasMinViewWidth = useMediaQuery({
    query: "(min-width: ".concat(props.minWidthToShowButtonText, "px)")
  });
  var stickyHeight = isDesktop ? 64 : 56;

  var onBackPress = function onBackPress() {
    if (!props.preventDefault || !props.onBack) {
      handleBackAction({
        history: history,
        location: location,
        backOverride: props.backOverride,
        match: match
      });
    }

    if (props.onBack) {
      props.onBack();
    }
  };

  var VerticalSubtext = function VerticalSubtext(props) {
    return /*#__PURE__*/React.createElement(VerticalSubTextContainer, {
      hasActions: props.hasActions
    }, props.title && /*#__PURE__*/React.createElement(Title, {
      "data-testid": ACTION_STRIP_TITLE,
      customTitleStyle: props.customTitleStyle
    }, props.title), props.subtext && /*#__PURE__*/React.createElement(Subtitle, {
      "data-testid": ACTION_STRIP_SUBTEXT,
      sticky: props.sticky,
      customSubtextStyle: props.customSubtextStyle
    }, props.subtext));
  };

  var HorizontalSubtext = function HorizontalSubtext(props) {
    return /*#__PURE__*/React.createElement(HorizontalSubtextContainer, {
      hasActions: props.hasActions
    }, props.title && /*#__PURE__*/React.createElement(Title, {
      "data-testid": ACTION_STRIP_TITLE,
      customTitleStyle: props.customTitleStyle
    }, props.title), props.subtext && /*#__PURE__*/React.createElement(Subtitle, {
      "data-testid": ACTION_STRIP_SUBTEXT,
      sticky: props.stickyScroll,
      customSubtextStyle: props.customSubtextStyle
    }, " ".concat(props.subtext)));
  };

  return /*#__PURE__*/React.createElement(Container, {
    "data-testid": ACTION_STRIP,
    className: props.className,
    showInverted: props.showInverted,
    withSideNav: props.withSideBarNav,
    stickyHeight: stickyHeight,
    scrollPercent: scrollPercent
  }, props.showInverted && !isDesktop ? /*#__PURE__*/React.createElement(InvertedStrip, {
    leftActions: props.invertedLeftActions,
    stripColor: props.invertedStripColor,
    stripTransitionColor: props.invertedStripTransitionColor,
    stickyHeight: stickyHeight,
    scrollPercent: scrollPercent,
    onBack: onBackPress,
    showBack: props.showBack,
    subtext: props.invertedSubText,
    showTitleOnLoad: props.showTitleOnLoad,
    showSubtextOnLoad: props.showSubtextOnLoad,
    icon: props.icon,
    title: props.showResponsiveTitle ? props.invertedTitle : null,
    children: props.children,
    verticalSubText: props.verticalSubText,
    verticalScrollHeight: props.verticalScrollHeight || 6,
    scrollIcon: props.invertedScrollIcon,
    childrenIcons: props.invertedChildrenIcons,
    childrenIconsScrolled: props.invertedChildrenIconsScrolled,
    titleColorOnLoad: props.titleColorOnLoad,
    subtextColorOnLoad: props.subtextColorOnLoad,
    showChildrenIconsOnLoad: props.showChildrenIconsOnLoad
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Content, {
    top: props.top,
    stripColor: props.stripColor,
    scrollPercent: scrollPercent,
    sticky: props.stickyScroll,
    stickyHeight: stickyHeight,
    withSideNav: props.withSideBarNav,
    "data-testid": 'action-strip-content',
    ref: ref
  }, /*#__PURE__*/React.createElement(Constrainer, {
    scrollPercent: scrollPercent,
    stickyHeight: stickyHeight,
    minWidth: ref === null || ref === void 0 ? void 0 : (_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.offsetWidth,
    maxWidth: props.maxWidth,
    customStyle: props.customStyle,
    withSideNavEnabled: props.withSideBarNav
  }, /*#__PURE__*/React.createElement(TitleContainer, null, props.leftActions.map(function (action) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, action.overrideComponent ? /*#__PURE__*/React.createElement(React.Fragment, null, action.overrideComponent) : /*#__PURE__*/React.createElement(ActionButton, {
      danger: action.danger,
      actionBackgroundColor: action.actionBackgroundColor,
      key: action.id,
      icon: action.icon,
      text: hasMinViewWidth ? action.text : null,
      onPress: action.handler,
      tooltip: action.tooltip,
      actionText: action.actionText,
      testId: action.testId,
      className: action.className
    }));
  }), props.showBack && props.leftActions.length === 0 && /*#__PURE__*/React.createElement(BackButtonStyled, {
    className: props.className,
    onClick: onBackPress
  }, props.backIcon || /*#__PURE__*/React.createElement(AcornsIcon, {
    icon: AcornsIcon.Icon.ArrowLeft,
    width: "17px",
    height: "12px"
  })), /*#__PURE__*/React.createElement(MediaQuery, {
    minWidth: theme.breakpoints.sm + 1
  }, props.verticalSubText ? /*#__PURE__*/React.createElement(VerticalSubtext, props) : /*#__PURE__*/React.createElement(HorizontalSubtext, props)), props.hasStickySettings && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ScreenReaderOnly, null, "Go to settings"), /*#__PURE__*/React.createElement(SettingsButtonStyled, {
    sticky: props.stickyScroll,
    onClick: props.onSettingsPress
  })), props.savedLabel && /*#__PURE__*/React.createElement(SavedLabel, {
    show: props.savedLabel.saved,
    text: props.savedLabel.text
  })), /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: theme.breakpoints.sm
  }, props.verticalSubText ? /*#__PURE__*/React.createElement(VerticalSubtext, _extends({}, props, {
    hasActions: !!(props.children || props.actions)
  })) : /*#__PURE__*/React.createElement(HorizontalSubtext, _extends({}, props, {
    hasActions: !!(props.children || props.actions)
  }))), props.heading, /*#__PURE__*/React.createElement(ActionContainer, {
    showMobileActions: props.showMobileActions,
    customStyle: props.customStyle,
    sticky: props.stickyScroll,
    showInverted: props.showInverted
  }, props.action && props.action, props.actions && props.actions.map(function (action) {
    return action.overrideComponent ? /*#__PURE__*/React.createElement(React.Fragment, null, action.overrideComponent) : /*#__PURE__*/React.createElement(ActionButton, {
      danger: action.danger,
      actionBackgroundColor: action.actionBackgroundColor,
      actionFadeColor: action.actionFadeColor,
      customButtonStyle: action.customButtonStyle,
      key: action.id,
      icon: action.icon,
      text: hasMinViewWidth ? action.text : null,
      onPress: action.handler,
      tooltip: action.tooltip,
      actionText: action.actionText,
      testId: action.testId,
      className: action.className
    });
  }), props.children))), isDesktop && /*#__PURE__*/React.createElement(Underline, {
    scrollPercent: scrollPercent,
    withSideNav: props.withSideBarNav,
    "data-testid": UNDERLINE,
    stickyHeight: stickyHeight
  })));
};